<ng-container *ngIf="field">
  <p class="c-label">{{ field.label }}</p>
  <ng-container [ngSwitch]="field.type">
    <p class="c-value" *ngSwitchDefault [innerHTML]="value.value | linkify"></p>

    <p class="c-value" *ngSwitchCase="'DATE'">{{ $any(value.value) | date: 'mediumDate' }}</p>

    <p class="c-value" *ngSwitchCase="'NUMBER'">{{ $any(value.value) | formatNum: field.format }}</p>

    <ng-container *ngSwitchCase="'SINGLESELECT'">
      <ng-container *ngTemplateOutlet="singleValue"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'RADIOBUTTONSLIST'">
      <ng-container *ngTemplateOutlet="singleValue"></ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="'MULTISELECT'">
      <ng-container *ngTemplateOutlet="multiValue"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'CHECKBOXESLIST'">
      <ng-container *ngTemplateOutlet="multiValue"></ng-container>
    </ng-container>
  </ng-container>

  <ng-template #singleValue>
    <p class="c-value">{{ $any(optionsMap[$any(value.value)?.[0]])?.label }}</p>
  </ng-template>

  <ng-template #multiValue>
    <p class="c-value">
      <span class="m-item" *ngFor="let v of $any(value.value)">{{ $any(optionsMap[v])?.label }}</span>
    </p>
  </ng-template>
</ng-container>
